import './App.css';
import { useEffect, useState } from 'react';
import { KeywordAnalysisPage } from './pages/KeywordAnalysisPage';
import ContentEnginePage from './pages/ContentEnginePage';

function App() {
  const [route, setRoute] = useState<string>(window.location.hash || '#/keyword');
  // iframe으로 로드되었는지 확인
  const isInIframe = window.self !== window.top;

  useEffect(() => {
    const handler = () => setRoute(window.location.hash || '#/keyword');
    window.addEventListener('hashchange', handler);
    return () => window.removeEventListener('hashchange', handler);
  }, []);

  const goto = (hash: string) => {
    if (window.location.hash !== hash) {
      window.location.hash = hash;
    } else {
      setRoute(hash);
    }
  };

  return (
    <div className="app-shell">
      {/* iframe에서 로드될 때는 네비게이션 숨기기 */}
      {!isInIframe && (
        <nav style={{ display: 'flex', gap: 8, padding: '10px 12px' }}>
          <button onClick={() => goto('#/keyword')} className={route === '#/keyword' ? 'btn btn-primary' : 'btn'}>
            키워드 분석
          </button>
          <button onClick={() => goto('#/content-engine')} className={route === '#/content-engine' ? 'btn btn-primary' : 'btn'}>
            글 작성 엔진
          </button>
        </nav>
      )}
      <div style={{ paddingTop: isInIframe ? 0 : 8 }}>
        {route.startsWith('#/content-engine') ? <ContentEnginePage /> : <KeywordAnalysisPage />}
      </div>
    </div>
  );
}

export default App;
